import React from "react";
import partsData from "../../Data/G3WO_Parts.json";
import PartsSearch from "./PartsSearch";
import "./PartsSearch.css"; // NEW: Page-specific styling

const PartsSearchPage = () => {
  return (
    <div className="wd-partsPage">
      <div className="wd-partsPage__inner">
        <div className="wd-partsPage__header">
          <p className="wd-partsPage__eyebrow">Technical Archive</p>
          <h1 className="wd-partsPage__title">Parts Lookup</h1>
          <p className="wd-partsPage__blurb">
            Search parts books in the same vintage workshop style as the rest of the site.
            Choose a machine, then cross-reference by description, section, or part number.
          </p>
        </div>

        <PartsSearch data={partsData} />

        <section className="wd-partsPage__note">
          <p>
            Prices displayed in pre-decimal (£/s/d) format as listed in wartime contracts C6094,
            C7183 and C8078.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PartsSearchPage;
